/* global System */
// register component(s) with react habitat

export default { Downloads: () => System.import('./index') }
